const Validations = require('../helpers/Validations');
const utils = require('../utils/Utils');

function Subscription() {
	this.init();
}

Subscription.prototype = {
	init: function() {
		this.$footer = $('.site-footer');
		this.$formOpener = this.$footer.find('.subscribe-link-js');
		// this.$formContainer = $('.sendsay-wrapper');
		this.$formContainer = this.$footer.find('.subscribe-js');
		this.$form = this.$formContainer.find('form');
		this.apiUrl = this.$form.data('api-url');
		this.$input = this.$form.find('input');
		this.$btn = this.$form.find('.subscribe-btn');
		this.$btnClose = this.$formContainer.find('.close-btn');
		this.$thxBox = this.$formContainer.find('.subscribe__thx');

		this.$formOpener.on('click', e => {
			e.preventDefault();
			this.$formContainer.fadeIn();
			// $('.sendsay-wrapper').fadeIn();
			// if (!this.$btnClose) {
			// 	$('.sendsay-wrapper .sendsay-column').append('<button type="button" class="close-btn sendsay-close-btn-js"></button>');
			// 	this.$btnClose = $('.sendsay-close-btn-js');
			// 	this.$btnClose.on('click', e => {
			// 		e.preventDefault();
			// 		$('.sendsay-wrapper').fadeOut();
			// 	});
			// }
			// $('.sendsay-wrapper input.sendsay-input').focus();
			this.$input.focus();
		});

		this.$btnClose.on('click', e => {
			e.preventDefault();
			this.$formContainer.fadeOut();
		});

		this.$input.on(
			'input change',
			utils.debounce(e => {
				if (e.type == 'input' || e.type == 'change') {
					e.preventDefault();
					const val = this.$input.val();
					val.length ? this.$btn.fadeIn() : this.$btn.fadeOut();
					const willSubmit = Validations.test(this.$form);
					willSubmit ? this.unlockSubmite() : this.lockSubmite();
				}
			}, 200)
		);

		this.$form.on('submit', e => {
			e.preventDefault();
			const willSubmit = Validations.test(this.$form);
			willSubmit ? this.submite() : this.lockSubmite();
		});
	},
	lockSubmite() {
		this.$btn.addClass('_disabled');
	},
	unlockSubmite() {
		this.$btn.removeClass('_disabled');
	},
	submite() {
		const self = this;
		$.ajax({
			method: this.$form.attr('method'),
			url: this.$form.attr('action'),
			data: this.$form.serialize(),
		})
			.done(function(response) {
				self.$form.hide();
				self.$thxBox.fadeIn();
				setTimeout(function() {
					self.$formContainer.fadeOut();
				}, 10000);
			})
			.fail(function(error) {
				console.log(error);
			});
	},
};

module.exports = new Subscription();
